import { apiFetch } from './client';

export interface AuditEntry {
  timestamp: string;
  action: string;
  /** 'cognito-user' appears only on rows written before the identity-service cutover */
  actorType: 'user' | 'cognito-user' | 'system' | 'public';
  actorId: string;
  targetType: string;
  targetId: string;
  metadata?: Record<string, unknown>;
}

export interface ListAuditResponse {
  month: string;
  items: AuditEntry[];
  nextToken?: string;
}

export const listAuditEntries = (month?: string, nextToken?: string) => {
  const params = new URLSearchParams();
  if (month) {
    params.set('month', month);
  }
  if (nextToken) {
    params.set('nextToken', nextToken);
  }
  const query = params.toString();
  return apiFetch<ListAuditResponse>(`/api/v1/audit${query ? `?${query}` : ''}`);
};
